/**
 * @fileoverview CorteConversion collection type definitions
 * Generated from model.json structure
 */

import type { BaseRecord } from '../common/PocketBaseTypes';

/**
 * CorteConversion interface based on PocketBase model.json
 * Collection ID: pbc_2148226793
 */
export interface CorteConversion extends BaseRecord {
  /** ID del papel/material (relación con material: pbc_1022373260) */
  papel?: string;
  /** Array de IDs de parámetros (relación con corte_conversion_tabla: pbc_3411037027) */
  parametro?: string[];
}

/**
 * Type for creating new CorteConversion records
 * Omits system fields that are auto-generated
 */
export type CreateCorteConversionData = Omit<CorteConversion, 'id' | 'created' | 'updated'>;

/**
 * Type for updating CorteConversion records
 * All fields are optional except system fields
 */
export type UpdateCorteConversionData = Partial<CreateCorteConversionData>;

/**
 * CorteConversion with expanded relations
 */
export interface CorteConversionExpanded extends CorteConversion {
  expand?: {
    /** Expanded papel record */
    papel?: import('./Material').Material;
    /** Expanded parametro records */
    parametro?: import('./CorteConversionTabla').CorteConversionTablaExpanded[];
  };
}

/**
 * Collection metadata for CorteConversion
 */
export const CORTE_CONVERSION_COLLECTION = {
  name: 'corte_conversion',
  id: 'pbc_2148226793',
  type: 'base',
  system: false,
  rules: {
    list: 'admin || supervisor',
    view: 'authenticated',
    create: 'admin || supervisor',
    update: 'admin || supervisor',
    delete: 'admin || supervisor' // This collection allows delete
  }
} as const;
